import { Navigate, useLocation } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import legacyRedirects from "@/data/legacyRedirects.json";

export const EXACT = legacyRedirects.exact;
export const PREFIX = legacyRedirects.prefix;

export const resolveLegacy = (pathname) => {
  let path = pathname;
  try { path = decodeURIComponent(pathname); } catch { /* conserver le chemin brut */ }
  path = path.replace(/\/+$/, "") || "/";
  if (EXACT[path]) return EXACT[path];
  const lower = path.toLowerCase();
  for (const [prefix, destination] of PREFIX) if (lower.startsWith(prefix)) return destination;
  return null;
};

export const LegacyRedirect = () => {
  const { pathname } = useLocation();
  const destination = resolveLegacy(pathname);
  return destination ? <Navigate to={destination} replace /> : <NotFound />;
};